import $ from 'jquery';
import template from 'lodash/template';
import { mobileDetection, renderAd } from '../../../js/utilities';
import 'slick-carousel';
import 'unveil2/dist/jquery.unveil2.min';

let opts = {};
const defaults = {
    slick: {
        dots: false,
        speed: 500,
        infinite: true,
        adaptiveHeight: true,
        fade: true,
        responsive: [
            {
                breakpoint: 480,
                settings: 'unslick'
            }
        ]
    }
};

class Carousel {

  constructor(opts = {}) {
    if (!this.initialized) {
        this.initialize(opts);
    }
  }

  // set arrow buttons just in case
  setNexPrev(ev, slick, currentSlide) {
    if(typeof currentSlide !== 'undefined') { this.current = currentSlide + 1; }
    location.hash = this.current;
    this.refreshAd(this.current);

    // fire only for the initial (because there's no beforeChange)
    if(ev && ev.type === 'init') {
      // this.setOmniture(ev, slick, -9, this.current - 1);
      // for accessibility
      this.el.focus();
    }

    // set arrow buttons
    if(this.prev) {
      this.prev[( this.current === 1 ? 'add' : 'remove' ) + 'Class']('is-active');
    }
    if(this.next) {
      this.next[( this.current === slick.slideCount ? 'add' : 'remove' ) + 'Class']('is-active');
    }
  }

  gotoSlick(flag) {
    const newCurrent = parseFloat(location.hash.replace('#', ''));
    // do only when initial call or hash different from current slide
    if(flag === 'init' || this.current !== newCurrent) {
        this.loaded = false;
        this.current = newCurrent;
        this.el.slick('slickGoTo', (this.current - 1));
    }
  }

  refreshAd(idx) {
    if(typeof googletag === 'undefined' || idx % 3 !== 0) { return; }
    if(typeof googletag.pubadsReady === 'undefined') { return; }
    googletag.pubads().refresh();
  }

  injectAd(obj, idx) {
    if(typeof googletag === 'undefined' || idx % 3 !== 0) { return; }

    const tmpl = $('#teaser-ad-tmpl').html();
    console.log(tmpl);
    const compiled = template(tmpl);
    const data = { 
      size: 'fl',
      type: 'small',
      idx:  idx / 3,
      count: (idx / 3) + '_carousel',
      adsize: [300, 250]
    };
    obj.closest('.carousel-item').after(compiled(data));
    // googletag rendering
    googletag.cmd.push(function(){
      renderAd(data);
    });
  }

  // only for mobile
  imgLazyLoad() {
    const _self = this;

    if(mobileDetection()) {
      _self.el.find('img').unveil({ attribute: 'lazy' });
      _self.el.on('loaded.unveil', 'img', function(){
        const idx = $(this).data('idx');
        // inject ad
        _self.injectAd($(this), idx);
      });
    } else {
      _self.el.find('img').trigger('destroy.unveil');
    }
  }

  positionArrows(){
    const arrows = this.el.find('.slick-arrow');
    const target = this.el.find('[data-carousel-spacer]');

    if(target.length) {
        arrows.css({top: target.height() / 2});
    }
  }

  positionItems(){
    this.positionArrows();
    this.imgLazyLoad();
  }

  setSlick() {
    // do not set again for already initialized slick
    if(this.el.hasClass('slick-initialized')) { return; }

    this.el.on('init', this.setNexPrev.bind(this))
         .on('afterChange', this.setNexPrev.bind(this));
         // .on('beforeChange', this.setOmniture.bind(this));
    this.el.slick(this.settings.slick);

    if(this.next) { this.el.prepend(this.next); }
    if(this.prev) { this.el.prepend(this.prev); }

    this.gotoSlick('init');
    $(window).on('hashchange', this.gotoSlick.bind(this));
    this.positionItems();
    $(window).resize(this.positionItems.bind(this));
    // for accessibility
    $(window).on('keyup', (e) => {
      // left arrow
      if(e.keyCode === 37) { this.el.slick('slickPrev'); }
      // right arrow
      if(e.keyCode === 39) { this.el.slick('slickNext'); }
    });
  }

  initialize(opts) {
    this.settings = Object.assign({}, defaults, opts);
    this.el = this.settings.el;
    this.loaded = false;

    const next = this.el.data('carousel-next');
    if(next) { this.next = $('<a />', { href: next, class: 'slick-arrow slick-next gallery-next', text: 'Next Gallery' }); }
    this.prev = $('<a />', { href: '#', class: 'slick-arrow slick-prev gallery-prev' })
      .on('click', (e) => {
        e.preventDefault();
        $(document).trigger('gallery.inactivated');
      });

    const hash = location.hash ? parseFloat(location.hash.replace('#', '')) : undefined;
    this.current = isNaN(hash) ? 1 : hash;
    const omnitureForm = $('#omnitureParams');
    if(omnitureForm.length) {
        this.omniture = omnitureForm.find('[name="corus.pagename"]').val();
    }

    // if this is not inside gallery, trigger
    if(!this.el.closest('.gallery').length) {
        this.setSlick();

    // otherwise wait till "view" is triggered
    } else {
        $(document).on('gallery.activated', this.setSlick.bind(this));
        if(this.current !== 1) {
            $('.gallery [data-gallery-trigger]').trigger('click');
        }
    }

    this.imgLazyLoad();
    this.initialized = true;
  }

}

const init = () => {
  if(!$) { return; }
  $('.carousel').each(function(){
      new Carousel({ el: $(this) });
  });
};

$(document).ready(init);
